import { render, staticRenderFns } from "./ClientsComponent.vue?vue&type=template&id=a13e45ba"
import script from "./ClientsComponent.vue?vue&type=script&lang=js"
export * from "./ClientsComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientsComponent.vue?vue&type=style&index=0&id=a13e45ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports